module.exports = __webpack_public_path__ + "img/p2.f151a311.png";